export default __webpack_public_path__ + "static/buttercmsLogo-52d8bb7aab5df4ad78f63b33ed0efec1.svg";